export function getDeviceType() {
    const userAgent = navigator.userAgent;

    const isMobilePattern = /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isTabletPattern = /iPad|Tablet|Nexus 7|Nexus 10|KFAPWI/i;

    if (isTabletPattern.test(userAgent)) {
        return 'tablet';
    } else if (isMobilePattern.test(userAgent)) {
        return 'mobile';
    } else {
        return 'desktop';
    }
}
